class SliderVideo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSlider();
    this.setupVideoControls();
  }

  initSlider() {
    const swiper = new Swiper(this.querySelector(".video-slider-swiper"), {
      slidesPerView: "auto",
      loop: false,
      effect: "coverflow",
      // centeredSlides: true,
      coverflowEffect: {
        rotate: 0,
        stretch: 1,
        depth: 0,
        scale: 0.9,
        slideShadows: false,
      },
      spaceBetween: 0,
      centeredSlides: true,
      breakpoints: {
        768: {
          effect: "slide",
          slidesPerView: "auto",
          loop: false,
          centeredSlides: true,
        },
      },
    });

    if (window.innerWidth < 768) {
      swiper.slideTo(1);
    } else {
      swiper.slideTo(2);
    }

    window.addEventListener(
      "resize",
      function () {
        if (window.innerWidth < 768) {
          swiper.slideTo(1);
        } else {
          swiper.slideTo(0);
        }
      }.bind(this)
    );
  }

  setupVideoControls() {
    this.querySelectorAll(".video-slider__content").forEach(
      (videoContainer) => {
        const video = videoContainer.querySelector("video");
        const playButton = videoContainer.querySelector(
          ".video-slider__button-play"
        );
        const stopButton = videoContainer.querySelector(
          ".video-slider__button-stop"
        );
        const soundButton = videoContainer.querySelector(
          ".video-slider__button-sound"
        );
        const img = videoContainer.querySelector("img");

        const soundOnIcon = soundButton.querySelector(".sound-on");
        const soundOffIcon = soundButton.querySelector(".sound-off");

        if (video) {
          video.controls = false;
        }

        if (stopButton) {
          stopButton.style.display = "none";
        }

        const toggleVideo = () => {
          if (video) {
            if (video.paused) {
              img.style.display = "none";
              video
                .play()
                .catch((err) =>
                  console.error("Erreur en jouant la vidéo:", err)
                );
              if (playButton) playButton.style.display = "none";
              if (stopButton) stopButton.style.display = "flex";
            } else {
              video.pause();
              if (playButton) playButton.style.display = "flex";
              if (stopButton) stopButton.style.display = "none";
            }
          }
        };

        if (img) img.addEventListener("click", toggleVideo);
        if (video) video.addEventListener("click", toggleVideo);
        if (playButton) playButton.addEventListener("click", toggleVideo);
        playButton.addEventListener("click", () => {
          console.log("on a cliquer sur le playButton");
        });
        if (stopButton) stopButton.addEventListener("click", toggleVideo);

        if (soundButton) {
          soundButton.addEventListener("click", () => {
            if (video) {
              video.muted = !video.muted;
              soundOnIcon.style.display = video.muted ? "none" : "inline-block";
              soundOffIcon.style.display = video.muted
                ? "inline-block"
                : "none";

              if (video.muted) {
                // Lorsque le son est coupé
                soundButton.style.borderRadius = "15.25px";
                soundButton.style.background = "rgba(100, 210, 255, 0.30)";
                soundButton.style.boxShadow =
                  "0px 0px 10.675px 0px rgba(0, 0, 0, 0.05)";
                soundButton.style.backdropFilter = "blur(3.6309525966644287px)";
              } else {
                // Lorsque le son est activé
                soundButton.style.borderRadius = "15.25px";
                soundButton.style.background = "#64D2FF";
                soundButton.style.boxShadow =
                  "0px 0px 10.675px 0px rgba(0, 0, 0, 0.05)";
                soundButton.style.backdropFilter = "blur(3.6309525966644287px)";
              }
            }
          });
        }
      }
    );
  }
}

customElements.define("slider-video", SliderVideo);
